import { useRecordContext } from "react-admin";
import { Link, Typography } from "@mui/material";
import { formatPhoneNumber } from "@/utils/validators/inPlaceValidators";

interface PhoneFieldProps {
  source: string;
  label?: string;
  emptyText?: string;
}

export const PhoneField = ({ source, emptyText = "—" }: PhoneFieldProps) => {
  const record = useRecordContext();
  const value = record?.[source];

  if (!value) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyText}
      </Typography>
    );
  }

  const formatted = formatPhoneNumber(value);
  const digits = value.replace(/\D/g, "");

  return (
    <Link href={`tel:+1${digits}`} underline="hover">
      +1 {formatted}
    </Link>
  );
};
